// extracted by mini-css-extract-plugin
module.exports = {"favorites":"styles_favorites__Zo6U_"};